// 404 from the server's membership check, or an older server answering an
// unknown id with an empty project.
export const isProjectUnavailableResponse = (res) =>
  res?.response?.status === 404 ||
  (res?.data?.success === true && !res?.data?.project?._id);
